import { Component, OnInit, Output, EventEmitter, OnChanges, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConstantsService, LookupsService, RequestServiceModelView, AccountService } from '@app/base/core';
import { SocoHttpService } from '@app/soco/http';
import { BuilderService } from '@app/modules/builder';
import { triggerFormValidation, phoneNumber, focusFirstInvalidField } from '@app/shared/functions';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';

const moment = require('moment');
require('moment-weekday-calc');

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'service-lot-request',
  templateUrl: './service.lot.request.component.html',
  styleUrls: ['./service.lot.request.component.css']
})
export class ServiceLotRequestComponent implements OnInit, OnChanges, OnDestroy {
   public dateOptions: any = {
    alwaysShowCalendars: false,
    singleDatePicker: true,
    autoUpdateInput: true,
    showDropdowns: true,
    minDate: moment().addWorkdays(21),
    isInvalidDate: (date) => (date.day() === 0 || date.day() === 6)
};
public postServiceReqSubscription: Subscription;
userName: string;
  // Constructor with the variables declared for necessary services to be used across the component.
  constructor(public constantsSvc: ConstantsService,
    public socoHttp: SocoHttpService, public builderSvc: BuilderService, public accountSvc: AccountService,
    public lookupSvc: LookupsService, private datePipe: DatePipe) {
      this.userName = this.accountSvc.account.user.username;
     }

 // Global variables to be used across the component.
  _lotData: RequestServiceModelView[];
  builderServiceDetailslotForm: FormGroup;

  // Input and output events for the service grid
  @Output() updateGrid = new EventEmitter<any>();
  @Input() set lotdata(data: RequestServiceModelView[]) {
    this._lotData = data;
  }

  // On the initialization of the component the new From Group is initialized and the validators are set for the required fields.
  ngOnInit() {
    // Reactive Form Initialization
    this.builderServiceDetailslotForm = new FormGroup({
      'firstNamelot': new FormControl(null, Validators.required),
      'lastNamelot': new FormControl(null, Validators.required),
      'contactNumberExtension': new FormControl(
        null,
        Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern)
      ),
      'contactNumberlot': new FormControl(null, [Validators.required,
        Validators.pattern(this.constantsSvc.phoneNumberPattern)]),
      'requestType': new FormControl({ value: null, disabled: true }),
      'constructionSiteStatus': new FormControl({ value: null, disabled: true }),
      'buildingPointId': new FormControl({ value: null, disabled: true }),
      'lookerStatus': new FormControl({ value: null, disabled: true }),
      'esitmatedInstallDateofService': new FormControl({ value: null, disabled: true }),
      'actualInstallDateofService': new FormControl({ value: null, disabled: true }),
    });
  }

  // Capture the selected Gas request id from grid and display the data in form by using the patch Value function for form Group.
  ngOnChanges() {
    if (this._lotData !== undefined && this._lotData[0] !== undefined) {
      this.builderServiceDetailslotForm.reset();
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');

    this.builderServiceDetailslotForm.patchValue({
      firstNamelot: this._lotData[0].applicantContactName1,
      lastNamelot: this._lotData[0].applicantContactName2,
      contactNumberlot: this._lotData[0].applicantPhoneNumber,
      contactNumberExtension: this._lotData[0].applicantPhoneExtension,
      otherDeliveryPressure: this._lotData[0].applicantPhoneExtension,
      requestType: this._lotData[0].requestType,
      constructionSiteStatus: this._lotData[0].constructionSiteStatus,
      buildingPointId: this._lotData[0].buildingPointId,
      lookerStatus: this._lotData[0].lookerStatus ?
      ((this._lotData[0].lookerStatus.toLocaleLowerCase() === 'READY EXCEPT MATERIAL IN WAY'.toLocaleLowerCase()) ?
      this._lotData[0].lookerStatus : 'WORK IN PROGRESS') : 'WORK IN PROGRESS',
      esitmatedInstallDateofService: this.datePipe.transform(this._lotData[0].serviceNeededBy, 'MM/dd/yyyy'),
      actualInstallDateofService: this.datePipe.transform(this._lotData[0].actualInstallDateOfService, 'MM/dd/yyyy'),
    });
    this.builderServiceDetailslotForm.updateValueAndValidity();
    this.socoHttp.hidePleaseWait('ContainerAwaiter');
  }
    }
    ngOnDestroy() {
      if (this.postServiceReqSubscription) {
            this.postServiceReqSubscription.unsubscribe();
        }
    }


  // On click of submit the Form data is validated and if the form is valid,
  // The form data is assigned to RequestServiceModel and a http post call is made.
  // The success result is shown in swal and the error is handled by Soco Http Service.
  OnSubmit() {
    if (this.builderServiceDetailslotForm.valid) {
      const lotSubmitData = this._lotData[0];
      lotSubmitData.applicantContactName1 = this.builderServiceDetailslotForm.controls['firstNamelot'].value;
      lotSubmitData.applicantContactName2 = this.builderServiceDetailslotForm.controls['lastNamelot'].value;
      lotSubmitData.applicantPhoneNumber = phoneNumber(this.builderServiceDetailslotForm.controls['contactNumberlot'].value);
      lotSubmitData.applicantPhoneExtension = this.builderServiceDetailslotForm.controls['contactNumberExtension'].value;
      lotSubmitData.lotStatus = (this.lookupSvc.LotStatusTypes.find(x => x.itemName === this._lotData[0].lotStatus)).id;
      lotSubmitData.recUpdateDttm =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      lotSubmitData.recUpdateUsrId = this.userName;
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
      this.postServiceReqSubscription = this.builderSvc.PostServiceRequestBylotId(lotSubmitData).subscribe(result => {
         this.builderServiceDetailslotForm.patchValue({
          firstNamelot: result.data.applicantContactName1,
          lastNamelot: result.data.applicantContactName2,
          contactNumberlot: result.data.applicantPhoneNumber,
          contactNumberExtension: result.data.applicantPhoneExtension
        });
       swal(this.constantsSvc.lotDetailsUpdateSwal, '' , this.constantsSvc.successSwal);
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
         $('#lot_details').modal('hide');
        this.builderServiceDetailslotForm.controls['firstNamelot'].reset();
        this.builderServiceDetailslotForm.controls['lastNamelot'].reset();
        this.builderServiceDetailslotForm.controls['contactNumberlot'].reset();
        this.builderServiceDetailslotForm.controls['contactNumberExtension'].reset();
        this.updateGrid.emit('true');
      },
      (error) => {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.postRequestFail, this.constantsSvc.errorSwal);
      });
    } else {
      triggerFormValidation(this.builderServiceDetailslotForm);
      focusFirstInvalidField(this.builderServiceDetailslotForm);
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
    }
  }

  // On post request an update event is triggerd to the parent component service request.
  updateGridData() {
    this.updateGrid.emit('true');
  }

}


